<template>
  <div class="">
   <el-drawer :visible.sync="shareVisiable" direction="btt" :before-close="handleClose" :append-to-body="true" :with-header="false">
      <div class="content">
        <ul>
          <!-- // 1 ==> 朋友圈  2 ==> 朋友  0 ==> 直接弹出原生 -->
          <li @click="share(1)"  v-if="isShow">
            <div class="img"><img src="../../../static/pyq.png" alt="" /></div>
            <div class="tip">{{ $t('share.friend') }}</div>
          </li>
          <li @click="share(2)" v-if="isShow">
            <div class="img"><img src="../../../static/weixin.png" alt="" /></div>
            <div class="tip">{{ $t('share.wechat') }}</div>
          </li>
          <li @click="shareLink">
            <div class="img"><img src="../../../static/copyLink.png" alt="" /></div>
            <div class="tip">{{ $t('share.link') }}</div>
          </li>
        </ul>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import * as share from '../../../../utils/share.js';
export default {
  name: '',
  data() {
    return {
      msg: this.shareVisiable,
      isShow: true,
      // isShow 是true代表可以显示微信和朋友圈
      browerType: '',
      information: 'titlsasase',

   };
  },
  computed:{
    wxShare(){
        return this.$store.state.wxSharlink
    }
   
  },
  props: ['shareVisiable', 'pannelVisiable','shareContentUrl'],
  methods: {
    handleClose() {
      this.msg = false;
      this.$emit('closePannel', this.msg);
    },
    initBrowser() {
      const msg = share.sharePannel();
      if (msg == 'noshare') {
        this.isShow = false;
      }
      if (msg == 'ucShare') {
        this.browerType = 'uc';
      }
      if (msg == 'qqShare') {
        this.browerType = 'qq';
      }
    },
    share(shareType) {

      const config = {
        title: '今年观展您还在排队办证？猛戳这里快速完成观众登记！',
        desc: '10月26-29日，北京中国国际展览中心(新馆)，第19届中国国际采矿展将隆重举办，敬请期待！',
        url: this.shareContentUrl,
        img: 'http://hz2.richcyber.com:8081/e-show/shareLogo.jpg',
      };
      const brower = this.browerType;

      // console.log("接口地址是",config);
      share.switchShare(shareType, brower, config);
    },
    shareLink() {
      console.log(213);
      // 创建一个 Input标签
      const cInput = document.createElement('input');
      cInput.value = this.wxShare;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本域内容;
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('Copy');
      alert('复制成功'); // antd框架封装的通知,如使用别的UI框架，换掉这句
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
      console.log(655);
    },
  },
  
  created() {
    this.initBrowser();
    console.log(this.shareContentUrl);
  },
};
</script>
<style lang="scss" scoped>
.content {
  ul {
    display: flex;
    justify-content: space-around;
    align-items: center;
    list-style: none;
    margin: 0 auto;
    li {
      text-align: center;
      .img {
        width: 10.67vw;
        height: 10.67vw;
        margin: 0 auto;

        img {
          width: 100%;
          height: 100%;
        }
      }
      .tip {
        margin-top: 4.67vw;
        font-size: 3.7vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
</style>
<style scoped>
.el-drawer__wrapper >>> .el-drawer {
  border-radius: 20px 20px 0px 0px;
  height: 40vw !important;
  width: 100%;
  padding-top: 11.3vw;
  box-sizing: border-box;
}
</style>
